"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var defaultOptions = {
  ignoreErrors: [// Random plugins/extensions
  'top.GLOBALS', // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
  'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', 'Can\'t find variable: ZiteReader', 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose', // This is a result of changing scrollTop property on the body in ie11, warning only
  'Assignment to read-only properties is not allowed in strict mode', // Facebook borked
  'fb_xd_fragment', // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload', 'EBCallBackMessageReceived', // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage', 'Can\'t find variable: _gat', /_gat is not defined/i, 'ReferenceError: Can\'t find variable: _gat', '\'_gat\' is undefined', 'Uncaught TypeError: Property \'$\' of object', 'TypeError: Property \'$\' of object', '\'clickdesk_log\' is undefined', 'TypeError: Unable to delete property.', 'd is null', 'Branch SDK initialization failed, so further methods cannot be called', /__gCrWeb\.autofill\.extractForms/i, // https://groups.google.com/a/chromium.org/forum/#!topic/chromium-discuss/7VU0_VvC7mE
  'InvalidPointerId', 'Request blocked by client, probably adblock', /NPObject/i, // Security Error: Blocked a frame with origin "https://spothero.com" from accessing a frame with origin "https://rs.gwallet.com". Protocols, domains, and ports must match.
  // There isn't an error being thrown from code located at https://rs.gwallet.com/
  'https://rs.gwallet.com'],
  blacklistUrls: [// Facebook flakiness
  /graph\.facebook\.com/i, // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i, // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i, // Chrome extensions
  /extensions\//i, /^chrome:\/\//i, // Firefox extensions
  /^moz-extension:\/\//i, // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i, /my\.clickdesk\.com\/clickdesk-ui\/browser\//i, /js-agent\.newrelic\.com/i, /bam\.nr-data\.net/i, /maps\.google\.com/i, /maps(-api-v3)?\/api\/js/i, /branch/i, /typeform/i, /answerdash/i, /instream\/video\/client\.js/i]
};
/**
 * Utilities for working with Sentry.
 * @module SentryUtils
 */

var _default = {
  /**
   * Adds additional data to the context in the global scope
   * @static
   * @function init
   * @param {Object} data - The initialization data.
   * @param {String} data.apiKey - The Sentry API key.
   * @param {Boolean} [data.isAuthenticated] - Whether the user has been authenticated or not.
   * @param {String} [data.email] - An email to associate with the authenticated user.
   * @param {String|Number} [data.id] - A unique ID associated with the authenticated user.
   * @param {String} [data.release] - A unique release ID to associate the bundled JS build with.
   * @param {String} [data.environment] - A Sentry environment to associate the bundled JS build with.
   * @param {Boolean} [data.debug] - Whether to turn on debugging to print out useful information if something goes wrong with sending an event to Sentry.
   * @param {Object} [data.additionalSentryOptions] - Additional initialization options to pass to Sentry.
   * @example
   * SentryUtils.init({
   *     apiKey: 'http://...',
   *     isAuthenticated: false,
   *     environment: 'production'
   * });
   * @returns {void}
   */
  init: function init(_ref) {
    var apiKey = _ref.apiKey,
        additionalSentryOptions = _ref.additionalSentryOptions,
        isAuthenticated = _ref.isAuthenticated,
        email = _ref.email,
        id = _ref.id,
        release = _ref.release,
        environment = _ref.environment,
        _ref$debug = _ref.debug,
        debug = _ref$debug === void 0 ? false : _ref$debug;
    // merge arrays nested inside of the passed options with those in the default config options
    var options = (0, _mergeWith.default)({}, defaultOptions, additionalSentryOptions, function (a, b) {
      return (0, _isArray.default)(a) ? a.concat(b) : undefined; // eslint-disable-line no-undefined
    });
    Sentry.init((0, _objectSpread2.default)({
      dsn: apiKey,
      debug: debug,
      release: release,
      environment: environment,
      sendDefaultPii: true
    }, options));

    if (isAuthenticated) {
      this.setUser({
        email: email,
        id: id
      });
    }
  },

  /**
   * Adds additional data to the context in the global scope
   * @static
   * @function addData
   * @param {Object} [data=null] - The additional data to send to Sentry.
   * @example
   * SentryUtils.addData({
   *     foo: 'bar',
   *     baz: 'crux'
   * });
   * @returns {void}
   */
  addData: function addData(data) {
    Sentry.configureScope(function (scope) {
      scope.setExtra('data', data);
    });
  },

  /**
   * Clears additional context from the global scope.
   * @static
   * @function clearData
   * @example
   * SentryUtils.clearData();
   * @returns {void}
   */
  clearData: function clearData() {
    Sentry.configureScope(function (scope) {
      scope.setExtra('data', null);
    });
  },

  /**
   * Sets user data to associate a user to Sentry errors. You can pass no data when a user logs out to de-associate the user.
   * @static
   * @function setUser
   * @param {Object} [data={}] - The user data to send to Sentry.
   * @param {String} [data.email=null] - The user's email address.
   * @param {Object} [data.id=null] - The user's ID.
   * @example
   * SentryUtils.setUser({
   *     email: 'test@spothero.com',
   *     id: 123
   * });
   * @returns {void}
   */
  setUser: function setUser() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        email = _ref2.email,
        id = _ref2.id;

    Sentry.configureScope(function (scope) {
      scope.setUser({
        id: id,
        email: email
      });
    });
  },

  /**
   * Captures exception in Sentry.
   * @static
   * @function sendException
   * @param {Error} error - The exception to send to Sentry.
   * @example
   * SentryUtils.sendException(new Error('This is an error.'));
   * @returns {void}
   */
  sendException: function sendException(error) {
    Sentry.captureException(error);
  },

  /**
   * Captures message in Sentry.
   * @static
   * @function sendMessage
   * @param {Object} data - The message data to send to Sentry.
   * @param {String} data.message - The message to send to Sentry.
   * @param {String} [data.level='warning'] - The log level in Sentry.
   * @example
   * SentryUtils.sendMessage({message: 'This is an error.'});
   * @returns {void}
   */
  sendMessage: function sendMessage(_ref3) {
    var message = _ref3.message,
        _ref3$level = _ref3.level,
        level = _ref3$level === void 0 ? 'warning' : _ref3$level;
    Sentry.captureMessage(message, level);
  }
};
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(defaultOptions, "defaultOptions", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/sentry/sentry.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/sentry/sentry.js");
  leaveModule(module);
})();

;